var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse311(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FFDC5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse311);
export default __webpack_public_path__ + "static/media/Ellipse 31 (1).5f4e003e427c02338a8c88e4ee624bc1.svg";
export { ForwardRef as ReactComponent };